import { orderSummaryStatus } from "data/constant/order-summary-status";
import { orderSummaryProducts } from "data/constant/order-summary-products";
import { stationTypeOptions } from "data/constant/station-type";

export const initialFilterState = () => {
  return {
    startDate: null,
    endDate: null,
    searchKey: "",
    searchType: "orderId",
    order: "desc",
    type: {
      isSelectedAll: true,
      value: stationTypeOptions.map((option) => option.value),
    },
    status: {
      isSelectedAll: true,
      value: orderSummaryStatus.map((option) => option.value),
    },
    productCode: {
      isSelectedAll: true,
      value: orderSummaryProducts.map((option) => option.value),
    },
    page: 1,
    perPage: 10,
  };
};
